import * as yup from 'yup';

function name(formatMessage, isEdit) {
  if (isEdit) {
    return yup.string();
  }
  return yup
    .string()
    .required(
      formatMessage({
        id: 'NAME_IS_REQUIRED',
        defaultMessage: 'Name is required',
      }),
    )
    .max(
      100,
      formatMessage({
        id: 'NAME_MUST_BE_100_CHARACTERS_OR_LESS',
        defaultMessage: 'Name must be 100 characters or less',
      }),
    );
}

function value(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'VALUE_IS_REQUIRED',
      defaultMessage: 'Value is required',
    }),
  );
}

function description(formatMessage) {
  return yup
    .string()
    .max(
      100,
      formatMessage({
        id: 'DESCRIPTION_MUST_BE_100_CHARACTERS_OR_LESS',
        defaultMessage: 'Description must be 100 characters or less',
      }),
    )
    .nullable();
}

const validationSchema = (formatMessage, isEdit) =>
  yup
    .object({
      name: name(formatMessage, isEdit),
      value: value(formatMessage),
      description: description(formatMessage),
    })
    .required();

export default validationSchema;
